/**
 * Registro de flujos de onboarding (F1 plan Persona Moral).
 *
 * `registerOnboardingFlows()` se llama una vez al arranque del app (main.tsx).
 * Por ahora solo registra PF; `moralFlow` se añadirá en F3+ detrás del flag
 * `onboarding_moral_enabled`.
 */
import { onboardingFlowRegistry } from '@tankef/core-react';

import { fisicaFlow } from './fisicaFlow';
import { moralFlow } from './moralFlow';

export function registerOnboardingFlows(): void {
  onboardingFlowRegistry.register(fisicaFlow);
  // moralFlow se registra siempre; solo se resuelve cuando partyType=moral,
  // que requiere el flag onboarding_moral_enabled on (F2 gatea el selector PM).
  onboardingFlowRegistry.register(moralFlow);
}

export { fisicaFlow };
export {
  moralFlow,
  resolveMoralStepUrl,
  resolveMoralResumeUrl,
  deriveMoralUnlockedSteps,
  deriveMoralSealedSteps,
  deriveMoralCompletedSteps,
  isMoralStepCompleted,
  isMoralStepCompletedByBlocks,
  isRegistrationBlock,
  type MoralBackendBlocks,
  MORAL_ACCESS_URL,
  MORAL_ACCESS_STEP_URLS,
} from './moralFlow';
